// Reusable progress bar component for tracking long-running operations
// CREATED: For import operations and other measurable processes
// Shows visual progress with percentage, ratio display, and optional label

interface ProgressBarProps {
  current: number;
  total: number;
  label?: string;
  stage?: string;
  color?: 'primary' | 'success' | 'warning' | 'error';
  showPercentage?: boolean;
  showRatio?: boolean;
  className?: string;
}

export function ProgressBar({
  current,
  total,
  label,
  stage,
  color = 'primary',
  showPercentage = false,
  showRatio = true,
  className = ''
}: ProgressBarProps) {
  const percentage = total > 0 ? Math.round((current / total) * 100) : 0;

  const colorClasses = {
    primary: 'bg-primary-600',
    success: 'bg-green-600',
    warning: 'bg-yellow-600',
    error: 'bg-red-600'
  };

  return (
    <div className={`w-full ${className}`}>
      {/* Label and stats */}
      {(label || stage || showRatio || showPercentage) && (
        <div className="flex items-center justify-between mb-2">
          <div className="flex flex-col">
            {label && (
              <span className="text-sm font-medium text-gray-700">{label}</span>
            )}
            {stage && (
              <span className="text-xs text-gray-600">{stage}</span>
            )}
          </div>
          <div className="text-sm font-semibold text-gray-700">
            {showRatio && (
              <span>{current} / {total}</span>
            )}
            {showRatio && showPercentage && <span className="mx-1">•</span>}
            {showPercentage && (
              <span>{percentage}%</span>
            )}
          </div>
        </div>
      )}

      {/* Progress bar */}
      <div className="w-full bg-gray-200 rounded-full h-3 overflow-hidden">
        <div
          className={`${colorClasses[color]} h-full transition-all duration-300 ease-out rounded-full`}
          style={{ width: `${percentage}%` }}
        />
      </div>
    </div>
  );
}
